








































import { Vue, Component } from 'vue-property-decorator'
import FilterForm from '@/components/LayerFilterForms/FilterForm.vue'
import { Departement } from '@/orrm/model/departement'
import { Phenomene } from '@/orrm/model/phenomene'
import { search, storage } from '@/store/modules'
import { ActuFilterCriteria } from '@/store/search'

@Component({
  components: { FilterForm }
})
export default class ActuFilterForm extends Vue {
  get criterias (): ActuFilterCriteria {
    return search.actuCriterias
  }

  get years (): number[] {
    const years: number[] = []
    const from = 2017
    const to = (new Date()).getFullYear()

    for (let i = 0; from + i <= to; i++) {
      years.push(from + i)
    }
    return years
  }

  get departements (): Departement[] {
    return storage.departements
  }

  get phenomenes (): Phenomene[] {
    return storage.phenomenes
  }

  get loadingDepartements (): boolean {
    return storage.loadingDepartements
  }

  get loadingPhenomenes (): boolean {
    return storage.loadingPhenomenes
  }

  async created () {
    await Promise.all([
      storage.initPhenomenes(),
      storage.initDepartements()
    ])
  }
}
